import { useUserSessionStore } from "../../stores/UserSession.store";
import { useFirebaseData } from "../../@shared/hooks/useFirebaseData";
import { Collections } from "../../@core/constants/FirebasePaths";
import { Queries } from "../../@core/constants/Queries";
import { functions } from "../../firebase/config";
import { IProvider, IProviderForm } from "../../@core/interfaces/IProvider";

export const useProviders = (loadData = false) => {
  const user = useUserSessionStore((state) => state.user);
  const { getReference } = useFirebaseData({ loadData: false });
  const db = useFirebaseData<IProvider>({
    collectionPath: `${Collections.users._path}`,
    loadData,
    queries: [
      ...Queries.trash,
      {
        type: 'where',
        field: 'role',
        operator: '==',
        value: 'provider'
      },
      {
        type: 'where',
        field: 'company',
        operator: '==',
        value: getReference(`users/${user.id}`)
      }
    ]
  });

  const createProvider = async (data: IProviderForm) => {
    const imageUrl = data.imageUrl;

    delete data.imageUrl;

    const createUserFunction = functions.httpsCallable("api/user/create");

    const authUserData = await createUserFunction({
      ...data,
      role: 'provider'
    });

    await db.update(authUserData.data.uid, {
      company: db.getReference(`users/${user.id}`)
    });

    await handleUploadFile(`users/${authUserData.data.uid}`, authUserData.data.uid, imageUrl);

    return authUserData.data.uid;
  };

  const handleUploadFile = async (path: string, docId: string, file: any) => {
    const ref = `${path}/photo`;
    const imageUrl = await db.uploadFile(file[0], ref);

    await db.update(docId, { imageUrl });
  };

  const updateProvider = async (id: string, data: Partial<IProvider>) => {
    await db.update(id, data);
  };

  const deleteProvider = async (id: string) => {
    await db.trash(id);
  };

  return {
    providers: db.data,
    createProvider,
    updateProvider,
    deleteProvider,
    fetched: db.fetched,
    handleUploadFile
  };
};
